var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuyCoinHistory = function SvgBuyCoinHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 1.667c.46 0 .833.373.833.833V11h-1.667V3.333H4.167v13.334L9 16.666v1.667H3.333A.833.833 0 0 1 2.5 17.5v-15c0-.46.373-.833.833-.833h13.334Zm-7 7.5v1.666h-3V9.167h3Zm3.666-3.334V7.5H6.667V5.833h6.666Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.071 11 1.061 1.054-1.545 1.489h5.805v1.475l-5.798-.001 1.538 1.498-1.069 1.054-2.837-2.772A.742.742 0 0 1 9 14.273a.73.73 0 0 1 .226-.523L12.07 11Z",
    fill: "currentColor"
  }))));
};
export default SvgBuyCoinHistory;